import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../../../components/BusComponent';

class DealsFromSelectedList extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    openDealsPanel = () => {
        this.emit('OPEN_DEAL_LIST_PANEL', {
            activeDealList: this.props.activeDealList,
        });
    };

    render() {
        const { activeDealList } = this.props;

        const count = (activeDealList && activeDealList.dealsCount) || 0;

        const dealsCountText = count === 1 ? '1 deal' : `${count} deals`;

        return (
            <div className="deals-from-selected-list-container" onClick={this.openDealsPanel}>
                <div className="deals-from-selected-list-container__counter-part">
                    <div className="deals-from-selected-list-container__icon-container">
                        <i className="material-symbols-outlined">warehouse</i>
                    </div>

                    <h6>{dealsCountText}</h6>
                </div>

                <div className="deals-from-selected-list-container__arrow-icon-container">
                    <i className="material-symbols-outlined">keyboard_arrow_right</i>
                </div>
            </div>
        );
    }
}

DealsFromSelectedList.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    activeDealList: PropTypes.object,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(DealsFromSelectedList);
